import { useStartVettingCheck } from '../hooks/useVettingActions';
import { getErrorMessage } from './VettingActionModal';
import { VettingDialog } from './VettingDialog';

type SendVettingCheckModalProps = {
  providerId: string;
  open: boolean;
  onClose: () => void;
};

/**
 * Confirmation step before the Checkr invitation is sent — the invitation emails
 * the provider and can't be unsent, so a single misclick must not trigger it.
 */
export function SendVettingCheckModal({ providerId, open, onClose }: SendVettingCheckModalProps) {
  const startCheck = useStartVettingCheck();

  return (
    <VettingDialog
      open={open}
      onClose={onClose}
      title="Send Vetting Check"
      description="Are you sure you want to send the background check to this provider?"
      confirmLabel="Send Vetting Check"
      pendingLabel="Sending..."
      isPending={startCheck.isPending}
      onConfirm={() => startCheck.mutate({ providerId }, { onSuccess: onClose })}
    >
      {startCheck.isError && (
        <p className="text-sm text-red-600">
          {getErrorMessage(startCheck.error, 'Could not send the vetting check. Please try again.')}
        </p>
      )}
    </VettingDialog>
  );
}
